// extracted by mini-css-extract-plugin
module.exports = {"autocomplete":"suggestions_autocomplete__93mAW","active":"suggestions_active__FgEL8","item":"suggestions_item__PxDmD"};